import { render } from "./StorefrontFooter.vue?vue&type=template&id=96d9c6e8&scoped=true"
import script from "./StorefrontFooter.vue?vue&type=script&lang=js"
export * from "./StorefrontFooter.vue?vue&type=script&lang=js"

import "./StorefrontFooter.vue?vue&type=style&index=0&id=96d9c6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d9c6e8"]])

export default __exports__